import { IconButton, keyframes } from "@chakra-ui/react";
import { EmrEar } from "@medstonetech/slate-icons";
import { useHHERAllyContext } from "contexts";
import * as React from "react";

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
`;

function HHERAllyToggle() {
  const { isRecording, startListening, stopListening, openPanel } =
    useHHERAllyContext();

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    if (isRecording) {
      await stopListening();
    } else {
      await startListening();
    }

    openPanel();
  };

  return (
    <IconButton
      aria-label={isRecording ? "Stop listening" : "Start listening"}
      icon={<EmrEar style={{ width: "9px", height: "13px" }} />}
      onClick={handleClick}
      width="30px"
      height="30px"
      minWidth="30px"
      padding="0"
      borderRadius="full"
      border="1px solid"
      borderColor="white"
      backgroundColor={isRecording ? "#34C759" : "#FF3B30"}
      color="white"
      _hover={{
        backgroundColor: isRecording ? "#2DA84A" : "#D9322A",
      }}
      animation={isRecording ? `${pulse} 1.5s infinite ease-in-out` : undefined}
    />
  );
}

export { HHERAllyToggle };
